/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Support_MessageInputs */

const en_billing_support_message = /** @type {(inputs: Billing_Support_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For billing assistance, contact us at`)
};

const fr_billing_support_message = /** @type {(inputs: Billing_Support_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour toute question relative à la facturation, veuillez nous contacter à l'adresse suivante :`)
};

const de_billing_support_message = /** @type {(inputs: Billing_Support_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei Fragen zur Abrechnung kontaktieren Sie uns bitte unter`)
};

const it_billing_support_message = /** @type {(inputs: Billing_Support_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per assistenza sulla fatturazione, contattaci a`)
};

const ru_billing_support_message = /** @type {(inputs: Billing_Support_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По вопросам выставления счетов обращайтесь к нам по адресу:`)
};

const es_billing_support_message = /** @type {(inputs: Billing_Support_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para obtener ayuda con la facturación, contáctenos en`)
};

const zh_cn2_billing_support_message = /** @type {(inputs: Billing_Support_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如需账单方面的帮助，请联系我们。`)
};

const ja_billing_support_message = /** @type {(inputs: Billing_Support_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請求に関するサポートについては、`)
};

const hi_billing_support_message = /** @type {(inputs: Billing_Support_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिल संबंधी सहायता के लिए, हमसे संपर्क करें।`)
};

const pt_pt2_billing_support_message = /** @type {(inputs: Billing_Support_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para obter assistência com a faturação, entre em contacto connosco através do seguinte endereço:`)
};

/**
* | output |
* | --- |
* | "For billing assistance, contact us at" |
*
* @param {Billing_Support_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const billing_support_message = /** @type {((inputs?: Billing_Support_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Support_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_billing_support_message(inputs)
	if (locale === "de") return de_billing_support_message(inputs)
	if (locale === "it") return it_billing_support_message(inputs)
	if (locale === "ru") return ru_billing_support_message(inputs)
	if (locale === "es") return es_billing_support_message(inputs)
	if (locale === "zh-CN") return zh_cn2_billing_support_message(inputs)
	if (locale === "ja") return ja_billing_support_message(inputs)
	if (locale === "hi") return hi_billing_support_message(inputs)
	if (locale === "pt-PT") return pt_pt2_billing_support_message(inputs)
	return en_billing_support_message(inputs)
});